<template>
  <div ref="rootRef" class="collage-carousel">
    <!-- FONDO ROSA -->
    <div ref="bgRef" class="bg-rosa"></div>

    <!-- 🌸 FLORES Y RAMAS EN ORILLAS -->
    <!-- Superior Izquierda -->
    <div class="deco-wrapper deco-lt">
      <img src="@/assets/rama.png" class="rama-img" />
      <img src="@/assets/fl.png" class="flor-img" />
    </div>

    <!-- Inferior Derecha -->
    <div class="deco-wrapper deco-rb">
      <img src="@/assets/rama.png" class="rama-img" />
      <img src="@/assets/fl.png" class="flor-img" />
    </div>

    <!-- IMÁGENES -->
    <div class="collage-grid">
      <div
        v-for="(image, index) in images"
        :key="index"
        ref="collageItems"
        class="collage-item"
        @click="enlargeImage(index)"
      >
        <img
          :src="image"
          class="collage-image"
          :alt="'Imagen ' + index"
        />
      </div>
    </div>

    <!-- MODAL -->
    <div
      v-if="isImageEnlarged"
      class="image-modal"
      @click="closeModal"
    >
      <img
        :src="images[currentIndex]"
        class="enlarged-image"
      />
    </div>

    <div class="rasgado rasgado-inferior"></div>
  </div>
</template>

<script>
import { ref, onMounted, nextTick } from 'vue'
import gsap from 'gsap'

export default {
  name: 'CollageAnimadoMagico',
  setup() {
    const images = [
      require('@/assets/IMG_4451.webp')
    ]

    const rootRef = ref(null)
    const bgRef = ref(null)
    const collageItems = ref([])

    const currentIndex = ref(0)
    const isImageEnlarged = ref(false)

    const enlargeImage = (index) => {
      currentIndex.value = index
      isImageEnlarged.value = true
    }

    const closeModal = () => {
      isImageEnlarged.value = false
    }

    onMounted(async () => {
      await nextTick()

      const flores = rootRef.value.querySelectorAll('.flor-img')
      const ramas = rootRef.value.querySelectorAll('.rama-img')
      const wrappers = rootRef.value.querySelectorAll('.deco-wrapper')

      // Estados iniciales
      gsap.set(bgRef.value, { opacity: 0 })
      gsap.set(flores, { opacity: 0, scale: 0.8, y: 15 })
      gsap.set(ramas, { opacity: 0, scale: 0, transformOrigin: 'center center' })
      gsap.set(collageItems.value, { opacity: 0, y: 40 })

      const io = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return

          const tl = gsap.timeline({ defaults: { ease: 'power3.out' } })

          // 1. Fondo
          tl.to(bgRef.value, { opacity: 1, duration: 0.6 })

          // 2. Flores
          tl.to(flores, {
            opacity: 1,
            scale: 1,
            y: 0,
            duration: 0.7,
            stagger: 0.2
          }, '-=0.3')

          // 3. Ramas brotando delicadamente
          tl.to(ramas, {
            opacity: 0.8,
            scale: 1.2,
            duration: 1.2,
            stagger: 0.2,
            ease: "elastic.out(1, 0.7)"
          }, '-=0.5')

          // Animación flotante sutil para los grupos decorativos
          wrappers.forEach((wrapper, i) => {
            gsap.to(wrapper, {
              y: `+=${gsap.utils.random(8, 15)}`,
              rotate: gsap.utils.random(-3, 3),
              duration: gsap.utils.random(3, 5),
              repeat: -1,
              yoyo: true,
              ease: 'sine.inOut',
              delay: i * 0.5
            })
          })

          // 4. Fotos
          tl.to(collageItems.value, {
            opacity: 1,
            y: 0,
            duration: 0.8,
            stagger: 0.2
          }, '-=0.8')

          io.disconnect()
        })
      }, { threshold: 0.3 })

      if (rootRef.value) io.observe(rootRef.value)
    })

    return {
      images, rootRef, bgRef, collageItems, currentIndex,
      isImageEnlarged, enlargeImage, closeModal
    }
  }
}
</script>

<style scoped>
.collage-carousel {
  position: relative;
  width: 100%;
  min-height: 70vh;
  margin-bottom: -40px;
  overflow: hidden;
}

.bg-rosa {
  position: absolute;
  inset: 0;
  background: #d6cabd;
  z-index: 0;
}

/* 🌸 DECORACIONES */
.deco-wrapper {
  position: absolute;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
}

.flor-img {
  width: 120px;
  max-width: 35vw;
  position: relative;
  z-index: 2;
}

.rama-img {
  position: absolute;
  width: 280px !important; /* Más grande que la flor para que sobresalga */
  max-width: 90vw;
  margin-top:80px;
  z-index: 1;
  filter: brightness(1.1);
}

.deco-lt { top: 6vh; left: -30px; }
.deco-rb { bottom: 10vh; right: -30px; }

/* GRID */
.collage-grid {
  position: relative;
  z-index: 2;
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  padding: 8vh 0;
}

.collage-item {
  grid-column: span 12;
  opacity: 0;
  cursor: pointer;
  display: flex;
  justify-content: center;
  margin-bottom: 5vh;
}

.collage-image {
  width: 85%;
  max-width: 500px;
  border-radius: 8px;
  box-shadow: 0 10px 25px rgba(0,0,0,0.1);
  transition: transform 0.4s ease;
}

.collage-image:hover {
  transform: scale(1.03);
}

/* MODAL */
.image-modal {
  position: fixed;
  inset: 0;
  background: rgba(10, 10, 10, 0.95);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.enlarged-image {
  max-width: 90%;
  max-height: 85%;
  border-radius: 12px;
  box-shadow: 0 0 30px rgba(0,0,0,0.5);
}

.rasgado-inferior {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 60px;
  background: #d6cabd;
  clip-path: polygon(0% 80%, 25% 60%, 50% 85%, 75% 55%, 100% 75%, 100% 0%, 0% 0%);
  z-index: 12;
}
</style>